(() => {
  const showcaseSelector = '.featured-product--showcase';
  const mediaStageSelector = '[data-featured-product-media-stage]';
  const variantInputSelector = 'variant-selects input[type="radio"], variant-selects select';

  const selectedFinish = (showcase, variant) => {
    const selectedInput = showcase.querySelector('variant-selects input[type="radio"]:checked');
    const selectedSelect = showcase.querySelector('variant-selects select');

    return (
      selectedInput?.value ||
      selectedSelect?.selectedOptions?.[0]?.value ||
      variant?.option1 ||
      variant?.public_title ||
      ''
    );
  };

  const setSelectedFinish = (showcase, variant) => {
    const productInfo = showcase.closest('product-info');
    const mediaStage = showcase.querySelector(mediaStageSelector);
    const readout = showcase.querySelector('[data-featured-product-finish-readout]');
    const finish = selectedFinish(showcase, variant);

    if (productInfo && finish) {
      productInfo.dataset.selectedFinish = finish;
    }

    if (finish) {
      const slug = finish
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

      showcase.dataset.selectedFinish = finish;
      showcase.dataset.selectedFinishSlug = slug;
      mediaStage?.setAttribute('data-finish', slug);
      if (readout) readout.textContent = finish;
    }
  };

  const pulseMediaStage = (showcase) => {
    const mediaStage = showcase.querySelector(mediaStageSelector);

    if (!mediaStage) return;

    mediaStage.classList.remove('is-changing');
    window.clearTimeout(mediaStage.featuredProductShowcaseTimer);
    window.requestAnimationFrame(() => {
      mediaStage.classList.add('is-changing');
      mediaStage.featuredProductShowcaseTimer = window.setTimeout(() => {
        mediaStage.classList.remove('is-changing');
      }, 520);
    });
  };

  const initShowcase = (showcase) => {
    if (showcase.dataset.showcaseReady === 'true') return;

    showcase.dataset.showcaseReady = 'true';
    setSelectedFinish(showcase);

    const mediaStage = showcase.querySelector(mediaStageSelector);

    if (mediaStage && window.matchMedia('(pointer: fine)').matches) {
      mediaStage.addEventListener('pointermove', (event) => {
        const rect = mediaStage.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        mediaStage.style.setProperty('--fp-tilt-x', `${(x * 4).toFixed(2)}deg`);
        mediaStage.style.setProperty('--fp-tilt-y', `${(y * -4).toFixed(2)}deg`);
        mediaStage.style.setProperty('--fp-shift-x', `${(x * 1.2).toFixed(2)}rem`);
        mediaStage.style.setProperty('--fp-shift-y', `${(y * 1.2).toFixed(2)}rem`);
      });

      mediaStage.addEventListener('pointerleave', () => {
        mediaStage.style.setProperty('--fp-tilt-x', '0deg');
        mediaStage.style.setProperty('--fp-tilt-y', '0deg');
        mediaStage.style.setProperty('--fp-shift-x', '0rem');
        mediaStage.style.setProperty('--fp-shift-y', '0rem');
      });
    }

    showcase.addEventListener('change', (event) => {
      if (!event.target.matches(variantInputSelector)) return;

      setSelectedFinish(showcase);
      showcase.classList.add('is-selecting');
      window.setTimeout(() => showcase.classList.remove('is-selecting'), 220);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const productInfo = showcase.closest('product-info');

      showcase.featuredProductShowcaseUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event = {}) => {
        const { data } = event;

        if (!productInfo || data?.sectionId !== productInfo.dataset.section) return;

        setSelectedFinish(showcase, data.variant);
        pulseMediaStage(showcase);
      });
    }
  };

  const initAllShowcases = (root = document) => {
    root.querySelectorAll(showcaseSelector).forEach(initShowcase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllShowcases());
  } else {
    initAllShowcases();
  }

  document.addEventListener('shopify:section:load', (event) => initAllShowcases(event.target));
})();
